import { useAsertoApiWithAnonymousAccess } from '@aserto/console-common'

import { useClientConfig } from '../services/EnvConfigProvider'

export function useInternalConfigClient() {
  const envConfig = useClientConfig()
  const discoveryServiceUrl = envConfig.isDocker
    ? window.location.origin
    : envConfig.discoveryServiceUrl
  return useAsertoApiWithAnonymousAccess(`${discoveryServiceUrl}/api/v2`)
}
